import { render, staticRenderFns } from "./EditPersonModal.vue?vue&type=template&id=895f47da&scoped=true&"
import script from "./EditPersonModal.vue?vue&type=script&lang=js&"
export * from "./EditPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonModal.vue?vue&type=style&index=0&id=895f47da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895f47da",
  null
  
)

export default component.exports